"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuarterHourPeriodizer = void 0;
const constants_1 = require("../../../../constants");
const util_1 = require("../../../../util");
const sharedTypes_1 = require("../sharedTypes");
const DimensionedPeriodizer_1 = require("./DimensionedPeriodizer");
const debug = util_1.DEBUG_OVERRIDE || (util_1.NOT_LAMBDA && false);
const className = 'QuarterHourPeriodizer';
/**
 * @class QuarterHourPeriodizer manages periodization for 1 month of quarter hour peridos
 */
class QuarterHourPeriodizer extends DimensionedPeriodizer_1.DimensionedPeriodizer {
    constructor(ob) {
        super(ob);
        this.timeBucketDefinition = {
            unit: util_1.TimeBucketUnits.QUARTERHOUR,
            width: 1,
        };
        this.timeBucketToAccessor = (timeBucketAccessor) => {
            const [y, m, d, h, min, s] = timeBucketAccessor;
            const thisAccessor = [(d - 1), h, Math.floor(min / 15)];
            return thisAccessor;
        };
        this.periodizerDaysLength = () => (0, util_1.daysInLastUTCMonth)(this.lastUpdatedTimestamp ?? 0);
        this.getFirstPossibleTimestamp = () => (this.lastUpdatedTimestamp ?? 0) - this.periodizerDaysLength() * constants_1.Milliseconds.DAY + 15 * constants_1.Milliseconds.MINUTE;
        this.accessorToTimestamp = (accessor) => {
            const startTimestamp = this.lastUpdatedTimestamp ?? 0;
            const currentAccessor = this.timestampToAccessor(startTimestamp);
            const [daysDiff, hoursDiff, quartersDiff] = accessor.map((v, i) => v - currentAccessor[i]);
            // handle rollover by when days same hour same quarter more, days same hour more, days more
            let absoluteNegativeDiff;
            const relativeDiff = daysDiff * constants_1.Milliseconds.DAY + hoursDiff * constants_1.Milliseconds.HOUR + quartersDiff * constants_1.Milliseconds.MINUTE * 15;
            if (relativeDiff > 0) {
                // absolute diff A + B is length of bucket minus how far ahead the accessor is xxxxx  [<---A---xxxxx--B-->]
                absoluteNegativeDiff = -(this.periodizerDaysLength() * constants_1.Milliseconds.DAY - relativeDiff);
            }
            else {
                absoluteNegativeDiff = relativeDiff;
            }
            const impliedTimestamp = startTimestamp + absoluteNegativeDiff;
            return impliedTimestamp;
        };
        this.isValidAccessor = (args) => {
            const isValid = args.length === this.arrayLengths?.length &&
                args.every((d, i) => d >= 0 && d < (this.arrayLengths?.[i] ?? 0)) &&
                args[0] <= this.periodizerDaysLength() - 1;
            if (!isValid) {
                debug && console.log(`Not valid accessor`, args);
            }
            return isValid;
        };
        if (!ob) {
            this.type = className;
            this.arrayLengths = sharedTypes_1.QuarterHourMonthBasedArrayDef;
            this.initialize();
        }
    }
}
exports.QuarterHourPeriodizer = QuarterHourPeriodizer;
